import React, {useState, useEffect, useRef} from 'react';

import {Link} from "react-router-dom"
import httpClient from '../fetch/fetch';
import Loader from './helpers/Loader';

function Error404() {

    const [loading, setloading] = useState(true);
    const [data, setdata] = useState("");

    const getData = () => {
        httpClient.get(`api/Evento/ObtenerParametroPorCodigo?codigo=NOTFOUND`)
        .then((res) => {
            // console.log(res.data[0]);
            setdata(res.data[0].valor);
        }).catch((err) => {

        });
    }
    
    useEffect(() => {
        if(loading){
            document.title = '404';
            getData();
        }
    }, [loading])
    
    return (
        <div>
            <header>
                <div className="container text-center">
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-sm-8 col-10">
                    <img 
                        src="https://recursos.exportemos.pe/evento/logo-app-exportemos.png" 
                        alt="" 
                        title="Eventos exportemos.pe v.0.0"
                        className="img-fluid"
                    />
                    </div>
                </div>
                </div>
            </header>
            <div className='vh-75 d-flex align-items-center'>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="card shadow">
                                <div className="card-body">
                                    <div className="py-4">
                                        {/* 
                                        <h1 style={{fontSize: "4rem"}} className='text-center text-primary fw-bold'>404</h1>
                                        */}
                                        <h2 className='fw-bold text-center my-3'>
                                            {data}
                                        </h2>
                                        {/* 
                                        <div className="text-center">
                                            <Link to={`/listar-eventos/i0520c8a892bf11eda1eb0242ac120002`} className='btn btn-primary shadow px-4 btn-lg fw-bold'>
                                                Volver al inicio
                                            </Link>
                                        </div>
                                        */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Error404